import React from 'react';
import PromoBanner from './PromoBanner';
import AnnouncementBanner from './AnnouncementBanner';
import useActiveAnnouncement from '../hooks/useActiveAnnouncement';

/**
 * Top-of-page banner orchestrator. When an announcement matches the current
 * user (mode === 'all' OR uid in target.uids), it overrides the promo
 * banner and renders in the same position — that's how admin announcements
 * take precedence over the coupon banner per the announcement spec.
 *
 * No announcement => fall back to the existing PromoBanner so today's
 * promo behaviour is preserved unchanged.
 */
export default function TopBanner() {
  const { announcement, dismiss } = useActiveAnnouncement();
  if (announcement) {
    return <AnnouncementBanner announcement={announcement} onDismiss={dismiss} />;
  }
  return <PromoBanner />;
}
